import { EcommerceTrackingData } from "./ecommerce-tracking-data.class";
export class StudyCardImpressionData extends EcommerceTrackingData {
    getTrackingContext() {
        return {
            organisationId: this.getOrganisationId(),
            studyId: this.getProductId(),
            scholarshipId: undefined,
            bodyId: undefined,
            premiumnessLevel: this.premium?.toString() ?? '',
            price: this.getUnitPrice(),
            position: this.listPosition,
            currency: this.getCurrency()
        };
    }
}
